import { ROUTE_RULES } from "./RoutePermissions";

export function hasPermissionForPath(pathname) {
  /* ——— 0) Super Admin ———————————————————— */
  console.log("PATHNAME SPLIT:", pathname, pathname.split("/"));
  const role = localStorage.getItem("userRole");
  const isSuperAdmin = Number(role) === 3 || role === "superadmin";
  if (isSuperAdmin) {
    console.log("%c[PERM] Super admin ➜ izin verildi", "color:green");
    return true;
  }

  /* ——— 1) Kullanıcı izinleri ————————————————— */
  const perms = JSON.parse(
    localStorage.getItem("permissions") ||
      sessionStorage.getItem("permissions") ||
      "[]",
  );
  console.log("%c[PERM] Pathname:", "color:gray", pathname);

  /* ——— 2) Route kuralı bul —————————————————— */
  const [matchedRoute, rule] =
    Object.entries(ROUTE_RULES).find(
      ([route]) => pathname === route || pathname.startsWith(route + "/"),
    ) || [];

  console.log(
    "%c[PERM] Eşleşen kural:",
    "color:gray",
    matchedRoute || "(yok)",
    rule || {},
  );

  if (!rule) {
    console.log("%c[PERM] Kural yok ➜ izin verildi", "color:orange");
    return true; // tanımsız path’lerde engelleme yok
  }

      if (rule.dynamic) {
        const slug = pathname.split("/")[2] || "";
        const value = decodeURIComponent(slug).trim().toLowerCase();

        // modules listesini de localStorage'da tut
        const modules = JSON.parse(localStorage.getItem("modules") || "[]");
        
        // slug'dan module_id bul
        const mod = modules.find(
          (m) => m.multiple_slug?.toLowerCase() === value ||
                m.single_slug?.toLowerCase() === value
        );

        if (!mod) {
          console.log("%c[PERM] Modül bulunamadı ➜ erişim engellendi", "color:red", value);
          return false;
        }

        // module_id ile permissions'da ara
        const perm = perms.find((p) => p.module_id === mod.id);
        const ok = !!perm?.[rule.required];

        console.log(
          `%c[PERM] Dinamik '${value}' (id:${mod.id}), gereken '${rule.required}' ➜ ${ok}`,
          `color:${ok ? "green" : "red"}`,
          perm || "eşleşme yok"
        );

  return ok;
}

  /* ——— 4) Statik modül ———————————————————— */
  const perm = perms.find((p) => p.module_key === rule.module_key);
  const ok = !!perm?.[rule.required]; // 1 / true → izin
  console.log(
    `%c[PERM] Statik '${rule.module_key}', gereken '${rule.required}' ➜ ${ok}`,
    `color:${ok ? "green" : "red"}`,
  );
  return ok;
}
